import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../Icon';
import './styles.css';

export const Toast = ({ 
  message, 
  type = 'success', 
  onClose, 
  duration = 3000 
}) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, duration - 300); // Commence l'animation de sortie 300ms avant la fin

    const closeTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  const iconName = {
    success: 'check-circle',
    error: 'x-circle',
    info: 'info'
  }[type];

  return createPortal(
    <div className={`toast toast-${type} ${isExiting ? 'toast-exit' : ''}`}>
      <div className="toast-content">
        <Icon name={iconName} size={24} className="toast-icon" />
        <span className="toast-message">{message}</span>
        <button className="toast-close" onClick={() => setIsExiting(true)}>
          <Icon name="x" size={20} />
        </button>
      </div>
    </div>,
    document.body
  );
}; 